"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Friend extends Api_1.default {
    constructor(props) {
        super(props);
    }
    /**
     * Remove from friend(s) the user(s) with the given user id(s).
     * If more than one, user ids are comma separated.
     * @param user_ids
     * @returns
     */
    delete(user_ids) {
        const requestObj = {
            method: 'delete',
            url: `/friend/${user_ids}`,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Friend;
